// VITE_MEDIA_URL тавигдаагүй бол VITE_API_URL-аас /api/vN хэсгийг тайлж авна.
// Жишээ: http://localhost:5001/api/v1 → http://localhost:5001
const _apiUrl = import.meta.env.VITE_API_URL as string | undefined
const MEDIA_BASE: string =
  (import.meta.env.VITE_MEDIA_URL as string | undefined) ||
  (_apiUrl ? _apiUrl.replace(/\/api\/v\d+\/?$/, '') : '')

/**
 * Backend-аас ирсэн харьцангуй URL-ийг бүрэн URL болгоно.
 * http/blob/data-аар эхэлсэн URL-ийг өөрчлөхгүй.
 */
export function resolveImg(url?: string | null): string | undefined {
  if (!url) return undefined
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url
  return `${MEDIA_BASE}${url}`
}

/**
 * "Firstname Lastname" → "Lastname Firstname" дараалалд хөрвүүлнэ
 */
export function formatName(fullName: string | undefined | null): string {
  if (!fullName) return ''
  const parts = fullName.trim().split(/\s+/)
  if (parts.length < 2) return fullName
  return `${parts[parts.length - 1]} ${parts.slice(0, -1).join(' ')}`
}

// Extract teacher name from populated teacher object
export function getTeacherName(course: any): string {
  if (!course?.teacherId) return ''
  if (course.teacherId.userId?.fullName) return formatName(course.teacherId.userId.fullName)
  if (typeof course.teacherId === 'string') return ''
  return course.teacherId.title || ''
}

// Format price as Mongolian Tugrik
export function formatPrice(price: number): string {
  if (price === 0) return 'Үнэгүй'
  return `${price.toLocaleString()}₮`
}

// Gradient list for cards
const gradients = [
  'from-orange-100 to-amber-200',
  'from-blue-100 to-cyan-200',
  'from-green-100 to-emerald-200',
  'from-purple-100 to-violet-200',
  'from-rose-100 to-pink-200',
  'from-amber-100 to-yellow-200',
  'from-teal-100 to-teal-200',
  'from-indigo-100 to-indigo-200',
]

export function getGradient(index: number): string {
  return gradients[index % gradients.length]
}

// Format date
export function formatDate(dateStr: string): string {
  const d = new Date(dateStr)
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`
}

export function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'Саяхан'
  if (mins < 60) return `${mins} минутын өмнө`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours} цагийн өмнө`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days} өдрийн өмнө`
  return formatDate(dateStr)
}
